import Cookies from "js-cookie";
import { getUuid } from "./uuid";
import { v4 } from "uuid";

export const track = (eventName: string, args = {}, meta = {}) => {
  const eventId = v4();

  fetch(
    "https://asia-northeast1-selects-161603.cloudfunctions.net/trackPostal",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...args,
        eventId,
        uuid: getUuid(),
        eventName,
        referrer: location.href,
        // Pixel ID
        fbp: Cookies.get("_fbp"),
        // クリックID
        fbc: Cookies.get("_fbc"),
      }),
    }
  ).catch((e) => {
    // Do nothing.
  });

  // @ts-ignore
  fbq("track", eventName, meta, { eventID: eventId });
};
